import { render, staticRenderFns } from "./ReportCardBill.vue?vue&type=template&id=310a2e9c&scoped=true&"
import script from "./ReportCardBill.vue?vue&type=script&lang=ts&"
export * from "./ReportCardBill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a2e9c",
  null
  
)

export default component.exports